module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Dr. Ammar Haouimi is a French trained internationally renowned radiologist and educator. His authored publications are:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Radiology for FRCR and MRCP 111 Cases")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Neuroradiology for FRCR and MRCP 111 Cases")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Pediatric Radiology Case Report 111 Common Cases")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Atlas of Pediatric Radiology 200 Common Cases")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Atlas of Neuroradiology 200 Common Cases")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Those publications were very successful and were enthusiastically welcomed by candidates appearing for Royal College Examinations. Like all previous publications, the current “Abdominal-Pelvic Imaging” will no doubt be another exceptional one. This book will not only be extremely helpful for residents, but also for referring physicians and practicing radiologists internationally.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0